import {
  APPROVE_LOAN_REQUESTS_ERROR,
  APPROVE_LOAN_REQUESTS_START,
  APPROVE_LOAN_REQUESTS_SUCCESS,
} from 'constants/action-types/loanRequests/approveLoanRequests';

export default (state, { type, payload }) => {
  switch (type) {
    case APPROVE_LOAN_REQUESTS_START:
      return {
        ...state,
        approveLoanRequest: {
          ...state.approveLoanRequest,
          loading: true,
          error: null,
        },
      };
    case APPROVE_LOAN_REQUESTS_ERROR:
      return {
        ...state,
        approveLoanRequest: {
          ...state.approveLoanRequest,
          error: payload,
          loading: false,
        },
      };
    case APPROVE_LOAN_REQUESTS_SUCCESS:
      return {
        ...state,
        approveLoanRequest: {
          ...state.approveLoanRequest,
          data: payload.data,
          error: null,
          loading: false,
        },
      };
    default:
      return null;
  }
};
